"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var PREFIX = 'SingleInsightItem';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    textWrapper: "".concat(PREFIX, "-textWrapper"),
    smallerCopy: "".concat(PREFIX, "-smallerCopy"),
    circleNumber: "".concat(PREFIX, "-circleNumber"),
    emptyCircleNumber: "".concat(PREFIX, "-emptyCircleNumber"),
    descriptionHeadingContainer: "".concat(PREFIX, "-descriptionHeadingContainer"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            display: 'flex',
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
        },
        _b[".".concat(classes.textWrapper)] = {
            flexGrow: 1,
            marginTop: theme.spacing(-0.375),
        },
        _b[".".concat(classes.circleNumber)] = {
            display: 'flex',
            justifyContent: 'center',
            width: 24,
            minWidth: 24,
            height: 24,
            borderRadius: 12,
            fontWeight: 500,
            fontSize: '16px',
            marginRight: '16px',
            color: theme.palette.common.white,
            backgroundColor: theme.palette.secondary.main,
        },
        _b[".".concat(classes.emptyCircleNumber)] = {
            border: "1px solid ".concat(theme.palette.common.black),
            backgroundColor: theme.palette.common.white,
        },
        _b[".".concat(classes.descriptionHeadingContainer)] = {
            color: 'hsl(0,0%,30%)',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: '20px',
            lineHeight: '30px',
        },
        _b[".".concat(classes.smallerCopy)] = {
            fontSize: theme.spacing(2),
            lineHeight: theme.spacing(3),
        },
        _b);
});
var SingleInsightItem = function (_a) {
    var size = _a.size, order = _a.order, children = _a.children, onClick = _a.onClick;
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, jsx_runtime_1.jsxs)(Root, __assign({ onClick: onClick, className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)(classes.circleNumber, !order && classes.emptyCircleNumber) }, { children: order })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.textWrapper, style: size === 'small' ? ({ marginTop: 0 }) : undefined }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)(classes.descriptionHeadingContainer, size === 'small' && classes.smallerCopy) }, { children: children })) }))] })));
};
exports.default = SingleInsightItem;
